<template>
  <div>
    <p class="mb-3">
      Find group by player id.
    </p>

    <form @submit.prevent="findRatings" class="mb-4">
      <div class="form-group mb-3">
        <label for="q" class="mb-1">Player id</label>
        <input id="q" v-model="playerIdStr" type="text" class="form-control" required>
      </div>

      <b-button type="submit" variant="primary">Find</b-button>
    </form>

    <div v-show="foundRatingIds !== null">
      <h3>Search results</h3>

      <p v-show="resultMessage !== null">
        {{resultMessage}}
      </p>

      <ul v-if="hasRatingIds">
        <li
          v-for="groupId in foundRatingIds"
          :key="groupId"
        >
          <contest-group-link :contestGroupId="createContestGroupId(groupId)"/>
        </li>
      </ul>

    </div>

  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import ContestGroupLink from './ContestGroupLink.vue';

export default {
  name: 'ContestGroupSearch',

  components: {
    ContestGroupLink
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      playerIdStr: '',

      /** @type {number[] | null} */
      foundRatingIds: null,
    };
  },

  computed: {
    /** @returns {?string} */
    resultMessage() {
      if(this.foundRatingIds !== null && this.foundRatingIds.length === 0) {
        return 'Ratings not found.';
      }
      return null;
    },

    /** @returns {boolean} */
    hasRatingIds() {
      const ratingIds = this.foundRatingIds;
      if(ratingIds === null) {
        return false;
      }

      return ratingIds.length > 0;
    },
  },

  watch: {
    playerIdStr() {
      this.resetSearchResults();
    },
  },

  methods: {
    findRatings() {
      notifier.deleteSenderNotifications(this);

      this.findRatingsByPlayerId();
    },

    findRatingsByPlayerId() {
      const trimmedPlayerIdStr = this.playerIdStr.trim();
      if(trimmedPlayerIdStr.length === 0) {
        notifier.showError('Player id must be specified.', {sender: this});
        return;
      }

      const playerId = parseInt(trimmedPlayerIdStr, 10);
      if(isNaN(playerId)) {
        notifier.showError('Player id must be an integer.', {sender: this});
        return;
      }

      const url = `/contest/${this.contestId}/rating_ids/find_by_player_id`;

      const requestConf = {
        params: {
          player_id: playerId.toString()
        }
      };

      HTTP.get(url, requestConf)
      .then(response => {
        const data = response.data.data;
        this.foundRatingIds = data;
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    resetSearchResults() {
      this.foundRatingIds = null;
    },

    /** @param {number} groupId */
    createContestGroupId(groupId) {
      return {
        contestId: this.contestId,
        groupId: groupId,
      };
    },
  },
};
</script>
